import { render, staticRenderFns } from "./activity-workshop-information.vue?vue&type=template&id=152cddcc&scoped=true&"
import script from "./activity-workshop-information.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-information.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-information.vue?vue&type=style&index=0&id=152cddcc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152cddcc",
  null
  
)

export default component.exports